<div>
  <button (click)="fireFreeMoneyRedeem()">Free money redeem</button>
  <input [formControl]="campaignIdFormControl" type="text" required>
</div>
